export default __webpack_public_path__ + "static/article-everything-you-need-to-know-about-personal-loans-832ed28e2761dc8782ccae0307dc776b.jpg";